import { Button } from '@/components/ui/button'
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from '@/components/ui/card'
import { AlertTriangle, ArrowLeft, Bug, Home } from 'lucide-react'
import React from 'react'
import { ErrorFallbackProps } from './ErrorBoundary'

export const ErrorFallback: React.FC<ErrorFallbackProps> = ({ resetError }) => {
    const handleGoBack = () => {
        // Go back in history and then reload to clear error state
        resetError()
        window.history.back()
        setTimeout(() => {
            window.location.reload()
        }, 100)
    }

    const handleGoHome = () => {
        window.location.href = '/dashboard/2hq'
    }

    return (
        <div className='flex items-center justify-center min-h-screen p-4 bg-gray-50'>
            <Card className='w-full max-w-md shadow-lg'>
                <CardHeader className='text-center'>
                    <div className='flex justify-center mb-4'>
                        <div className='p-3 bg-red-100 rounded-full'>
                            <AlertTriangle className='w-8 h-8 text-red-600' />
                        </div>
                    </div>
                    <CardTitle className='text-2xl font-bold text-gray-900'>Oops! Something went wrong</CardTitle>
                    <p className='mt-2 text-gray-600'>
                        We're sorry, but something unexpected happened. Our team has been notified and we're working on
                        a fix.
                    </p>
                </CardHeader>

                <CardContent className='text-center'>
                    <p className='mb-6 text-sm text-gray-500'>
                        You can go back to the previous page or return to the dashboard.
                    </p>
                </CardContent>

                <CardFooter className='flex flex-col gap-3'>
                    <div className='flex w-full gap-3'>
                        <Button onClick={handleGoBack} variant='outline' className='flex-1'>
                            <ArrowLeft className='w-4 h-4 mr-2' />
                            Go Back
                        </Button>

                        <Button onClick={handleGoHome} variant='brand' className='flex-1'>
                            <Home className='w-4 h-4 mr-2' />
                            Dashboard
                        </Button>
                    </div>

                    <div className='w-full mt-4 text-center'>
                        <a
                            href='/dashboard/support'
                            className='inline-flex items-center text-sm transition-colors text-primary-main hover:text-primary-text'
                        >
                            <Bug className='w-4 h-4 mr-1' />
                            Report this issue
                        </a>
                    </div>
                </CardFooter>
            </Card>
        </div>
    )
}
